<template>
  <div v-if="(Object.keys($page.props.errors).length > 0) && show" class="alert alert-danger alert-dismissible">
    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>
    <h5><i class="icon fas fa-ban"></i> Error</h5>
    <div v-if="detail">
      <ul>
        <li v-for="error in $page.props.errors">
          {{error}}
        </li>
      </ul>
    </div>
    <div v-else>
      <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
      <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
    </div>
  </div>
</template>

<script>
import toastr from 'toastr'

export default {
  props: {
    detail: Boolean,
  },
  data() {
    return {
      show: true
    }
  },
  watch: {
    '$page.props.flash': {
      immediate: true,
      handler() {
        let flash = this.$page.props.flash;
        if (flash && flash.success && !flash.shown) {
          toastr.success(flash.success, '', {
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            timeOut: 2000,
          })
          flash.shown = true;
        }

        if (flash && flash.error && !flash.shown) {
          this.$gtag.exception({
            'description': flash.error,
            'fatal': false
          })

          toastr.error(flash.error, '', {
            positionClass: 'toast-bottom-right',
            preventDuplicates: true,
            timeOut: 5000,
          })
          flash.shown = true;
        }
        
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
